import {Component, Input,Output, OnInit, EventEmitter} from '@angular/core';
import { UserService } from '../../Services/Users.service';
import {Configuration} from '../../config/config';
import { CreateCommunityService } from '../../Services/create-community.service';


declare var $;

@Component({
  selector: 'app-userkyc',
  templateUrl: './userkyc.component.html',
  styleUrls: ['./userkyc.component.css']
})
export class UserkycComponent implements OnInit {
  @Input() communityData : any;
  globalCommRoleList : Array<any> = [];
  globalBUnitList : Array<any> = [];
  communityRoleList : Array<any> = [];
  businessUnitList : Array<any> = [];
  comm_role = undefined;
  business_unit = undefined;
  isDisableBUnit: boolean = false;
  isDisableCommRole: boolean = false;
  countryCodeList : any;
  countryCode : string = undefined;
  community_id: any;
  country : string;
  countryId : string = undefined;
  userInfo: any;
  organizationList: any;
  fname: any;
  lname: any;
  organization: any;
  designation: any;
  phone: any;
  user1: string;
  showdesignation: boolean;
  showc_role: boolean;
  showb_unit: boolean;
  showfname: boolean;
  showlname: boolean;
  showphone: boolean;
  show_country: boolean;
   

  constructor(private userService: UserService,private communityService:CreateCommunityService) {
    this.countryCodeList = Configuration.countryCode;
  }

  ngOnInit() {
    // this.userService.refreshToken();
      this.userInfo = JSON.parse(localStorage.getItem('currentUser')).user;
    this.userService.usersProfilePic(this.userInfo.userid).subscribe(user => {
      console.log(user.data,'latest user array');
      this.country = user.data.country;
      if(this.country){
        this.show_country = true
      }
      else{
        this.show_country = false
      }
       this.comm_role = user.data.comm_role;
       if(this.comm_role){
        this.showc_role = true
      }
      else{
        this.showc_role = false
      }
       this.business_unit = user.data.business_unit;
       if(this.business_unit){
        this.showb_unit = true
      }
      else{
        this.showb_unit = false
      }
       this.community_id = user.data.community_id;
      this.designation = user.data.designation;
      if(this.designation){
        this.showdesignation = true
      }
      else{
        this.showdesignation = false
      }
       this.fname = user.data.first_name;
       if(this.fname){
        this.showfname = true
      }
      else{
        this.showfname = false
      }
       this.lname = user.data.last_name;
       if(this.lname){
        this.showlname = true
      }
      else{
        this.showlname = false
      }
       this.phone = user.data.phone;
       if(this.phone){
        this.showphone = true
      }
      else{
        this.showphone = false
      }
    this.getAllRoleBUnit();
    })
    
    console.log(this.userInfo.phone,"for userinfo phone");
    // this.communityService.getAllOrganizations().subscribe(res => {
    //   this.organizationList = res.data;
    //   console.log("Organization Data",this.organizationList);
    // });
    // this.communityService.getCommunityByID(this.community_id).subscribe(res => { 
    //     this.organization = res.data.org_name;
    // });    
  }

  getAllRoleBUnit(){
    this.userService.getRoleAndBusinessUnitById(this.community_id).subscribe(rb =>{
      if(rb.success){
        if(rb.data && rb.data.length > 0){
          let resArr = rb.data;
          let ind = resArr.findIndex(r=> r.comm_id == 'global');
          if(ind > -1){
            this.globalCommRoleList = resArr[ind].comm_role && resArr[ind].comm_role.length > 0 ? resArr[ind].comm_role : [];
            this.globalBUnitList = resArr[ind].business_unit && resArr[ind].business_unit.length > 0 ? resArr[ind].business_unit : [];
            resArr.splice(ind,1);
            if(resArr && resArr.length > 0){
              this.communityRoleList = resArr[0].comm_role && resArr[0].comm_role.length > 0 ? resArr[0].comm_role : this.globalCommRoleList;
              this.businessUnitList = resArr[0].business_unit && resArr[0].business_unit.length > 0 ? resArr[0].business_unit : [];
            }else{
              this.communityRoleList = (this.globalCommRoleList && this.globalCommRoleList.length > 0) ? JSON.parse(JSON.stringify(this.globalCommRoleList)) : [];
              this.businessUnitList = []; // JSON.parse(JSON.stringify(this.globalBUnitList));
            }
          }else{
            this.globalCommRoleList = [];
            this.globalBUnitList = [];
            let cind = resArr.findIndex(r=> r.comm_id == this.community_id);
            if(cind > -1){
              this.communityRoleList = resArr[cind].comm_role && resArr[cind].comm_role.length > 0 ? resArr[cind].comm_role : [];
              this.businessUnitList = resArr[cind].business_unit && resArr[cind].business_unit.length > 0 ? resArr[cind].business_unit : [];
            }else{
              this.communityRoleList = [];
              this.businessUnitList = [];
            }
          }
          this.follwRules();
        }
      }
    });
  }

  follwRules(){
    if(this.community_id == 'global'){
      this.businessUnitList = []; // JSON.parse(JSON.stringify(this.businessUnitList));
      this.business_unit = 'None';
      this.isDisableBUnit = true;
    }else{
      if(this.businessUnitList && this.businessUnitList.length > 0){
        if(this.businessUnitList.length == 1){
          this.isDisableBUnit = true;
          this.business_unit = this.businessUnitList[0];
        }else{
          this.isDisableBUnit = false;
        }
      } else{
        this.business_unit = 'None';
        this.isDisableBUnit = true;
      }
    }

    if(this.communityRoleList && this.communityRoleList.length > 0){
      //For CommRole
      if(this.communityRoleList.length == 1){
        this.isDisableCommRole = true;
        this.comm_role = this.communityRoleList[0];
      }else{
        this.isDisableCommRole = false;
      }
    } else{
      this.comm_role = 'None';
      this.isDisableCommRole = true;
    }
  }

  changeCountry(e){
    if(this.countryId){
      let ind = this.countryCodeList.findIndex(c=> c.iso2 == this.countryId);
      if(ind > -1){
        this.country = this.countryCodeList[ind].name;
        this.countryCode = this.countryCodeList[ind].code;
      }else{
        this.country = undefined;
        this.countryCode = undefined;
      }
    } else {
      this.country = "";
    }
  }

  

  saveKycInfo(userKycForm){  
    console.log(userKycForm);
    const newUser = {
      user_id: this.userInfo.userid,
      country : this.country,
      business_unit: this.business_unit,
      comm_role: this.comm_role,
      fname: this.fname,
      lname: this.lname,
      designation: this.designation,
      phone: this.phone,
      user_kyc: this.country && this.business_unit && this.comm_role && this.fname && this.lname && this.designation && this.phone ? true : false
    };
    console.log(newUser);
    
    this.userService.updateUserKYC(newUser).subscribe(user => {
      if(user.success){
        userKycForm.reset();
        $('#userKYCModal').modal('hide');
        sessionStorage.removeItem('loginPage');
      }
    });
    //   if(this.fname && this.lname){
    //     console.log('fname and lname kyc false')
    // this.userService.editUser1(newUser);
    //   }
    this.userService.usersProfilePic(this.userInfo.userid).subscribe(user => {
      console.log(user,"data after update")
  });
  }
}



// WEBPACK FOOTER //
// ./src/app/Screens/userkyc/userkyc.component.ts